import ConsumptionContainer from "./ConsumptionContainer";

export default ConsumptionContainer;
